import CollapseCategoryView from './CollapseCategoryView'

export default CollapseCategoryView
